/**
 * About Page GSAP Animations with ScrollTrigger
 */

class AboutPageAnimation {
  constructor() {
    this.contentCards = document.querySelectorAll('.about-content-card');
    this.init();
  }

  init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.warn('GSAP or ScrollTrigger not loaded');
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    // console.log('contentCards:', this.contentCards.length);

    // ScrollTriggerのデフォルト設定を変更
    ScrollTrigger.config({
      autoRefreshEvents: "visibilitychange,DOMContentLoaded,load",
      limitCallbacks: true
    });

    // ヒーローとヘッダーを完全固定（ScrollTrigger初期化前）
    const header = document.querySelector('header') || document.querySelector('.header-bar') || document.querySelector('#SiteHeader');
    const fixedElements = [
      { el: document.querySelector('.about-hero'), zIndex: 0 },
      { el: header, zIndex: 100 },
      { el: document.querySelector('.header'), zIndex: 100 },
      { el: document.querySelector('[data-section-type="header"]'), zIndex: 100 }
    ].filter(item => item.el); // 存在する要素のみ

    fixedElements.forEach(({ el, zIndex }) => {
      el.style.cssText = `
        position: fixed !important;
        ${zIndex === 0 ? 'top: 0 !important; left: 0 !important; width: 100vw !important; height: 100vh !important;' : ''}
        z-index: ${zIndex} !important;
        transform: translate3d(0, 0, 0) !important;
        will-change: transform;
        backface-visibility: hidden;
      `;
    });

    // ヒーローテキストのアニメーション設定
    const heroText = document.querySelector('.about-hero__text p');
    if (heroText) {
      // 初期状態: 非表示、左にずれ、ブラー
      gsap.set(heroText, {
        opacity: 0,
        x: -30,
        filter: 'blur(10px)'
      });

      // ページ読み込み時にアニメーション開始
      gsap.to(heroText, {
        opacity: 1,
        x: 0,
        filter: 'blur(0px)',
        duration: 1.2,
        delay: 0.5,
        ease: 'power2.out'
      });
    }

    // ScrollTriggerイベントでリセット（ズレを防ぐ）
    ScrollTrigger.addEventListener('refresh', () => {
      fixedElements.forEach(({ el }) => {
        el.style.transform = 'translate3d(0, 0, 0)';
      });

      // フッターも強制的にリセット
      const footerEl = document.querySelector('footer, .footer, .site-footer, [data-section-type="footer"]');
      if (footerEl && footerEl.style.position === 'fixed') {
        // console.log('🦶 Refresh: Resetting footer position');
        footerEl.style.transform = 'translate3d(0, 0, 0)';
      }
    });

    // body全体がズレないように監視（refreshの時のみ）
    const preventBodyShift = () => {
      document.body.style.transform = 'none';
      document.documentElement.style.transform = 'none';
    };

    // ScrollTriggerのrefresh時のみリセット（update時は重いので削除）
    ScrollTrigger.addEventListener('refresh', preventBodyShift);

    // 初期実行
    preventBodyShift();

    // フッター要素を取得して初期設定
    const footer = document.querySelector('footer, .footer, .site-footer, [data-section-type="footer"]');
    const isMobileAbout = window.innerWidth <= 749;

    if (footer) {
      // console.log('🦶 Footer element found:', footer);

      // フッターは固定位置で画面の下端（ちょうど見えない位置）に配置
      // 2枚目カードが上に移動すると、フッターも一緒に上に移動して見えてくる
      // z-indexは2枚目カード（11）と同じに設定
      footer.style.cssText = `
        position: fixed !important;
        top: 100vh !important;
        top: 100lvh !important;
        left: 0 !important;
        width: 100% !important;
        z-index: 11 !important;
        pointer-events: none !important;
        will-change: transform;
        backface-visibility: hidden;
      `;

      // フッター表示時の隙間対策：bodyの背景を黒に
      document.body.style.backgroundColor = '#000';

      // 定期チェックは重いので削除
    } else {
      console.warn('❌ Footer element not found');
    }

    const totalCards = this.contentCards.length;
    let secondCardScrollTrigger = null; // 2枚目のScrollTriggerを保存
    let firstCardScrollTrigger = null; // 1枚目のScrollTriggerを保存

    // フッター用のスクロール領域を先に追加（ScrollTrigger計算前に必要）
    if (footer) {
      // フッター高さをデバイスごとに適切に設定
      let footerHeight = footer.offsetHeight || window.innerHeight * 0.5;
      let extraSpacer = 0;
      // モバイル: カードスクロールアウト分 + フッターギャップ分
      if (isMobileAbout) {
        extraSpacer = Math.round(window.innerHeight * 1.2);
      }
      // タブレット（750px-1199px）: フッターが2段構成で高くなる + 追加スペース
      if (window.innerWidth >= 750 && window.innerWidth <= 1199) {
        extraSpacer = 200; // 足りない分を追加
      }
      const spacerHeight = footerHeight + extraSpacer;
      const footerScrollSpacer = document.createElement('div');
      footerScrollSpacer.className = 'footer-scroll-spacer';
      footerScrollSpacer.style.cssText = `
        height: ${spacerHeight}px;
        pointer-events: none;
      `;
      document.body.appendChild(footerScrollSpacer);
      // console.log('Footer spacer height:', spacerHeight, 'footerHeight:', footerHeight);
    }

    this.contentCards.forEach((card, index) => {
      const singleImage = card.querySelector('[data-image-type="single"]');
      const gridImages = card.querySelector('[data-image-type="grid"]');

      // z-indexを設定（後のカードほど上に重なる）
      card.style.zIndex = 10 + index;

      // デバッグ用：カードに半透明のボーダーを追加
      

      // 背景画像が設定されている場合
      const bgImageUrl = card.getAttribute('data-bg-image');
      const bgImageMobileUrl = card.getAttribute('data-bg-image-mobile');

      // モバイル判定（749px以下）
      const isMobile = window.innerWidth <= 749;
      const selectedBgImage = (isMobile && bgImageMobileUrl) ? bgImageMobileUrl : bgImageUrl;

      if (selectedBgImage) {
        card.style.backgroundImage = `url(${selectedBgImage})`;
        card.style.backgroundSize = 'cover';
        // モバイルの2枚目カード（背景画像付き）は背景を上寄りに
        card.style.backgroundPosition = (isMobile && index === 1) ? 'center 30%' : 'center';
        card.style.backgroundRepeat = 'no-repeat';

        // innerの背景を透明にする
        const cardInner = card.querySelector('.about-content-card__inner');
        if (cardInner) {
          cardInner.style.background = 'transparent';
        }

        // 背景画像がある場合は左側の画像エリアを非表示
        if (singleImage) singleImage.style.display = 'none';
        if (gridImages) gridImages.style.display = 'none';
      }

      // 状態追跡用
      let lastIsActive = false;

      // 各カードは、それ以降のカード分も含めて長くpinする
      const remainingCards = totalCards - index; // このカード以降のカード数
      // 1枚目のカードは画像キープ時間を追加
      // 全体的にゆったりスクロールさせるため倍率を上げる（モバイルはより長く、デスクトップもゆっくり）
      const imageKeepMultiplier = isMobileAbout ? 5.0 : 4.0; // 差を小さく
      const imageKeepTime = (index === 0) ? window.innerHeight * imageKeepMultiplier : 0;
      // 2枚目のカードは自身のpin時間（大きいほどスクロール量に対する移動がゆっくり）
      const secondCardKeepMultiplier = 1.0;
      const secondCardKeepTime = (index === 1) ? window.innerHeight * secondCardKeepMultiplier : 0;
      // フッター分の時間（フッター高さ分のスクロール領域が必要）- 削除してフッターは別途制御
      const footerExtraMultiplier = 0; // フッターはScrollTrigger終了後に別途制御
      const footerExtraTime = (index === 1) ? window.innerHeight * footerExtraMultiplier : 0;
      const pinDuration = window.innerHeight * 2.5 * remainingCards + imageKeepTime + secondCardKeepTime + footerExtraTime;

      // 2枚目の登場タイミング：1枚目の画像が鮮明に表示された後に登場
      // 各カードは前のカード分のアニメーション時間だけ遅延
      const delayOffset = index * window.innerHeight * 1.1; // 0, 2.3, 4.6, ... (1.0 + 0.6 + 0.5 + 1.2 = 3.3秒分のうち2.3を使用)

      // 初期状態：各カードを十分遠くに配置（完全に画面外）
      // 1枚目は見切れないように少し多めに下に配置
      // 2枚目以降をさらに下に配置（1枚目の後半キープが終わった後に登場するように）
      // 1枚目のpinDuration = innerHeight * 12、後半キープ終了は約innerHeight * 11付近
      // 2枚目のScrollTriggerは元のDOM位置基準なので、extraOffsetで遅らせる
      const extraOffsetMultiplier = 3.0; // 統一
      const extraOffset = (index > 0) ? window.innerHeight * extraOffsetMultiplier : 0;
      const initialY = index === 0
        ? window.innerHeight * 1.3
        : window.innerHeight * 1.2 + delayOffset + extraOffset;

      gsap.set(card, {
        y: initialY,
        rotation: -15,
        // 2枚目以降は初期非表示（画面侵入前に100%になる）
        opacity: index > 0 ? 0 : 1,
      });

      // タイムラインを作成
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: card,
          start: 'top bottom', // シンプルに元の位置基準
          end: `+=${pinDuration}`,
          scrub: 3.0, // モバイル・デスクトップ統一
          pin: true, // カードを固定
          pinType: 'fixed', // 明示的にfixedを指定
          pinSpacing: false, // 重ねるためスペースを確保しない
          pinReparent: false, // pin時にDOMを再配置しない（重要！）
          anticipatePin: 1,
          preventOverlaps: false, // 他のpinと干渉しないように
          fastScrollEnd: true, // 高速スクロール対応
          invalidateOnRefresh: false, // 不要なリフレッシュを防ぐ
          markers: true, // 必須: レイアウト計算に必要（CSSで非表示）
          onRefresh: () => {
            // pin-spacerラッパーにz-indexを設定
            const pinSpacer = card.parentElement;
            if (pinSpacer && pinSpacer.classList.contains('pin-spacer')) {
              pinSpacer.style.zIndex = String(10 + index);
            }
          },
          onLeave: () => {
            // endマーカーを通過した時（下スクロール）
            if (index === 0) {
              // 1枚目は非表示
              card.style.opacity = '0';
              card.style.pointerEvents = 'none';
            } else if (index === 1) {
              // 2枚目は固定表示を維持
              card.style.position = 'fixed';
              card.style.top = '0px';
              card.style.left = '0';
              card.style.right = '0';
              card.style.width = '100%';
              card.style.opacity = '1';
              card.style.pointerEvents = 'auto';
              card.style.zIndex = String(10 + index);
              // GSAPのscrubがtransformを上書きしないように、ScrollTriggerを無効化
              tl.scrollTrigger.disable();
              card._gsapDisabled = true;
            }
          },
          onEnterBack: () => {
            // endマーカーを通過して戻ってきた時（上スクロール）
            if (index === 0) {
              // 1枚目は非表示のまま
              card.style.opacity = '0';
              card.style.pointerEvents = 'none';
            } else if (index === 1) {
              // 2枚目は表示
              card.style.opacity = '1';
              card.style.pointerEvents = 'auto';
              // 注意: GSAPの再有効化はここでは行わない
              // リバースモード終了時（updateFooterPosition内）で行う
              // ここで再有効化すると状態がおかしくなる
            }
          },
          onLeaveBack: () => {
            // startマーカーを通過して戻る時（上スクロール）= カードが完全に画面外に出た
            if (index === 0) {
              card.style.opacity = '1';
              card.style.pointerEvents = 'auto';
              // テキストアニメーションをリセット（再度下スクロールで同じアニメーションが発火）
              if (card._resetSingleText) {
                card._resetSingleText();
              }
              // ヒーローテキストを再表示（アニメーション付き）- カードが完全に退場した後
              const heroText = document.querySelector('.about-hero__text p');
              if (heroText) {
                heroText._hidden = false; // フラグをリセット
                gsap.to(heroText, {
                  opacity: 1,
                  x: 0,
                  filter: 'blur(0px)',
                  duration: 1.0,
                  ease: 'power2.out'
                });
              }
            }
            if (index === 1) {
              // 2枚目カードのテキストアニメーションをリセット
              if (card._resetSecondCardText) {
                card._resetSecondCardText();
              }
            }
          },
          onUpdate: (self) => {
            const pinSpacer = card.parentElement;

            // isActiveの間のみ処理
            if (self.isActive) {
              if (index === 0) {
                const hideThreshold = isMobileAbout ? 0.98 : 0.95;
                if (self.progress >= hideThreshold) {
                  card.style.opacity = '0';
                  card.style.pointerEvents = 'none';
                } else {
                  card.style.opacity = '1';
                  card.style.pointerEvents = 'auto';
                }
                card.style.top = '0px';
                card.style.zIndex = String(10 + index);

                // ヒーローテキスト: カードが画面上部に到達したら裏で非表示（フェードなし）
                const heroText = document.querySelector('.about-hero__text p');
                if (heroText) {
                  // カードが画面トップに到達（progress >= 入場完了時点）したら非表示
                  const heroHideThreshold = 0.15; // 入場アニメーション完了時点
                  if (self.progress >= heroHideThreshold && !heroText._hidden) {
                    heroText._hidden = true;
                    gsap.set(heroText, {
                      opacity: 0,
                      x: -30,
                      filter: 'blur(10px)'
                    });
                  }
                }
              }

              if (index === 1) {
                card.style.opacity = '1';
                card.style.pointerEvents = 'auto';
                card.style.top = '0px';
                card.style.zIndex = String(10 + index);
              }
            }

            // pin-spacerラッパーにもz-indexを設定
            if (pinSpacer && pinSpacer.classList.contains('pin-spacer')) {
              pinSpacer.style.zIndex = String(10 + index);
            }

            // 状態変化時のみログ出力
            if (lastIsActive !== self.isActive) {
              lastIsActive = self.isActive;
            }
          }
        }
      });

      // 1枚目のScrollTriggerを保存
      if (index === 0) {
        firstCardScrollTrigger = tl.scrollTrigger;
        // console.log('📍 First card ScrollTrigger saved');
      }

      // 2枚目のScrollTriggerを保存
      if (index === 1) {
        secondCardScrollTrigger = tl.scrollTrigger;
        // console.log('📍 Second card ScrollTrigger saved:', {
        //   trigger: secondCardScrollTrigger.trigger,
        //   start: secondCardScrollTrigger.start,
        //   end: secondCardScrollTrigger.end
        // });

        // 2枚目のカードが確実に固定されるよう監視（モバイル・デスクトップ統一）
        // 注意：transformはフッターモードで制御するので、ここでは設定しない
        const ensureSecondCardFixed = () => {
          // モバイルフッター/リバースモードでは別途制御中のため、スキップ
          if (isMobileAbout && (card._footerMode || card._reverseMode)) return;
          if (window.scrollY > secondCardScrollTrigger.end) {
            card.style.position = 'fixed';
            card.style.top = '0px';
            card.style.left = '0';
            card.style.right = '0';
            card.style.width = '100%';
            card.style.opacity = '1';
            card.style.zIndex = '11';
            // transformはフッターモードのsmoothAnimationで制御するので、ここでは設定しない
          }
        };
        window.addEventListener('scroll', ensureSecondCardFixed, { passive: true });
      }

      // Phase 1: 入場アニメーション（移動と回転を同時に）
      // 1枚目の速度を基準に、2枚目も同じ速度（距離/時間）で移動
      // 1枚目: initialY = innerHeight * 1.3, duration = 1 → 速度 = 1.3 * innerHeight per duration
      const firstCardInitialY = window.innerHeight * 1.3;
      const firstCardDuration = 1.0;
      // 2枚目は同じ速度で移動するため、距離に比例したdurationを計算
      const entranceDuration = (index === 0)
        ? firstCardDuration
        : (initialY / firstCardInitialY) * firstCardDuration;

      if (index > 0) {
        // 2枚目：1枚目と同じ速度で移動
        // 最初は非表示のまま画面外を移動、画面に入る直前で表示
        const visibleThreshold = window.innerHeight * 0.1;
        const invisibleDistance = Math.max(0, initialY - window.innerHeight - visibleThreshold);
        const visibleDistance = initialY - invisibleDistance;

        // 非表示部分の移動（画面外）
        if (invisibleDistance > 0) {
          const invisibleRatio = invisibleDistance / initialY;
          tl.to(card, {
            y: initialY - invisibleDistance,
            rotation: -15,
            duration: entranceDuration * invisibleRatio,
            ease: 'none'
          });
        }

        // 表示
        tl.to(card, {
          opacity: 1,
          duration: 0.01,
          ease: 'none'
        });

        // 表示部分の移動（画面内へ、そしてy:0まで）
        const visibleRatio = visibleDistance / initialY;
        tl.to(card, {
          y: 0,
          rotation: 0,
          duration: entranceDuration * visibleRatio,
          ease: 'none'
        });
      } else {
        // 1枚目
        tl.to(card, {
          y: 0,
          rotation: 0,
          duration: entranceDuration,
          ease: 'none'
        });
      }


      // 1枚目のカードのナビリンクは完全に非表示
      if (index === 0) {
        const navLinks = card.querySelector('.about-nav-links');
        if (navLinks) {
          navLinks.style.display = 'none';
        }
      }

      // Phase 1.2: カードがトップに到達した後、最初のテキストを自動でスライドイン（1枚目のみ）
      if (index === 0) {
        // モバイル/デスクトップで適切なテキスト要素を選択
        const singleTextSelector = isMobileAbout
          ? '.about-content-card__text-group--mobile[data-text-type="single"]'
          : '.about-content-card__text-group--desktop[data-text-type="single"]';
        const singleText = card.querySelector(singleTextSelector);
        if (singleText) {
          // pタグの中身を<br>で分割して各行をspanで囲む
          const pElements = singleText.querySelectorAll('.about-content-card__body p');
          pElements.forEach(p => {
            const html = p.innerHTML;
            const lines = html.split('<br>');
            const wrappedLines = lines.map(line => `<span class="text-line">${line}</span>`).join('<br>');
            p.innerHTML = wrappedLines;
          });

          // heading と 各行のspanを取得
          const heading = singleText.querySelector('.about-content-card__heading');
          const textLines = singleText.querySelectorAll('.text-line');
          const allElements = [heading, ...textLines].filter(el => el);

          // 初期状態：非表示（ブラーも追加）
          gsap.set(allElements, {
            opacity: 0,
            x: -50,
            filter: 'blur(10px)'
          });

          // テキストアニメーションはtl.call()で一度だけ発火（上スクロールでは消えない）
          // onLeaveBackでリセットされるので、再度下スクロールで同じアニメーションが発火
          let singleTextAnimated = false;
          tl.call(() => {
            if (!singleTextAnimated) {
              singleTextAnimated = true;
              gsap.to(allElements, {
                opacity: 1,
                x: 0,
                filter: 'blur(0px)',
                duration: 1.0,
                stagger: 0.15,
                ease: 'power2.out'
              });
            }
          });

          // onLeaveBack用にリセット関数を保存
          card._resetSingleText = () => {
            singleTextAnimated = false;
            gsap.set(allElements, { opacity: 0, x: -50, filter: 'blur(10px)' });
          };
        }
      }

      // Phase 1.3: 2枚目のカードのテキストを自動でスライドイン
      if (index === 1) {
        // モバイル/デスクトップで適切なテキスト要素を選択
        const singleTextSelector = isMobileAbout
          ? '.about-content-card__text-group--mobile[data-text-type="single"]'
          : '.about-content-card__text-group--desktop[data-text-type="single"]';
        const singleText = card.querySelector(singleTextSelector);
        if (singleText) {
          // pタグの中身を<br>で分割して各行をspanで囲む
          const pElements = singleText.querySelectorAll('.about-content-card__body p');
          pElements.forEach(p => {
            const html = p.innerHTML;
            const lines = html.split('<br>');
            const wrappedLines = lines.map(line => `<span class="text-line">${line}</span>`).join('<br>');
            p.innerHTML = wrappedLines;
          });

          // heading と 各行のspanを取得
          const heading = singleText.querySelector('.about-content-card__heading');
          const textLines = singleText.querySelectorAll('.text-line');
          const allElements = [heading, ...textLines].filter(el => el);

          // 初期状態：非表示（ブラーも追加）
          gsap.set(allElements, {
            opacity: 0,
            x: -50,
            filter: 'blur(10px)'
          });

          // ナビリンクを取得（2枚目カード用）
          const navLinks = card.querySelector('.about-nav-links');

          // ナビリンクとスクロールインジケーターの初期状態
          const scrollIndicator = card.querySelector('.about-scroll-indicator');
          if (navLinks) {
            gsap.set(navLinks, { opacity: 0, visibility: 'hidden' });

            // デスクトップ：ナビリンクにホバーブラーエフェクトを追加（小さめのブラー）
            if (!isMobileAbout) {
              const blurCursor = document.querySelector('.header-blur-cursor');
              if (blurCursor) {
                const navLinkElements = navLinks.querySelectorAll('a');
                navLinkElements.forEach(link => {
                  link.addEventListener('mouseenter', () => {
                    blurCursor.classList.add('active', 'small');
                  });
                  link.addEventListener('mouseleave', () => {
                    blurCursor.classList.remove('active', 'small');
                  });
                });
              }
            }
          }

          // テキストアニメーションはtl.call()で一度だけ発火
          let secondCardTextAnimated = false;

          // テキストアニメーション開始位置にラベルを追加
          const secondCardTextLabel = 'secondCardText';
          tl.addLabel(secondCardTextLabel);
          const secondCardTextLabelTime = tl.labels[secondCardTextLabel];

          tl.call(() => {
            if (!secondCardTextAnimated) {
              secondCardTextAnimated = true;
              // テキストをフェードイン（ゆったり）
              const textAnimDuration = 1.0;
              const textStagger = 0.15;
              const textTotalTime = textAnimDuration + (allElements.length - 1) * textStagger;

              gsap.to(allElements, {
                opacity: 1,
                x: 0,
                filter: 'blur(0px)',
                duration: textAnimDuration,
                stagger: textStagger,
                ease: 'power2.out'
              });
              // スクロールインジケーターをフェードアウト
              if (scrollIndicator) {
                gsap.to(scrollIndicator, {
                  opacity: 0,
                  duration: 0.5,
                  ease: 'power2.out'
                });
              }
              // ナビリンクをフェードイン（テキストアニメーション終了後）
              if (navLinks) {
                gsap.to(navLinks, {
                  opacity: 1,
                  visibility: 'visible',
                  duration: 0.5,
                  delay: textTotalTime, // テキストアニメーション完了後に開始
                  ease: 'power2.out'
                });
              }
              // ヘッダーの色を反転（透明に）
              const header = document.querySelector('header') || document.querySelector('.header-bar') || document.querySelector('#SiteHeader');
              if (header) {
                header.classList.add('hdr-trans-hp');
              }
            }
          }, null, secondCardTextLabel);

          // タイムラインの進行を監視して、テキストアニメーション開始位置より前に戻ったらリセット
          // ※リバースモード中はlerpがprogressを制御しており、テキストを消すと一瞬見える問題が出るためスキップ
          tl.eventCallback('onUpdate', function() {
            if (card._reverseMode) return;
            const currentTime = tl.time();
            if (secondCardTextAnimated && currentTime < secondCardTextLabelTime) {
              secondCardTextAnimated = false;
              gsap.set(allElements, { opacity: 0, x: -50, filter: 'blur(10px)' });
              if (scrollIndicator) {
                gsap.set(scrollIndicator, { opacity: 1 });
              }
              if (navLinks) {
                gsap.set(navLinks, { opacity: 0, visibility: 'hidden' });
              }
              // ヘッダーの色を元に戻す（背景付き）
              const header = document.querySelector('header') || document.querySelector('.header-bar') || document.querySelector('#SiteHeader');
              if (header) {
                header.classList.remove('hdr-trans-hp');
              }
            }
          });

          // onLeaveBack用にリセット関数を保存（完全に画面外に出た時用）
          card._resetSecondCardText = () => {
            secondCardTextAnimated = false;
            gsap.set(allElements, { opacity: 0, x: -50 });
            if (scrollIndicator) {
              gsap.set(scrollIndicator, { opacity: 1 });
            }
            if (navLinks) {
              gsap.set(navLinks, { opacity: 0, visibility: 'hidden' });
            }
            // ヘッダーの色を元に戻す（背景付き）
            const header = document.querySelector('header') || document.querySelector('.header-bar') || document.querySelector('#SiteHeader');
            if (header) {
              header.classList.remove('hdr-trans-hp');
            }
          };
        }
      }

      // Phase 1.5: 1枚目のカードの場合、最初の画像を鮮明な状態でキープ
      // テキストを読む時間を確保（スクロール距離として長めに）
      if (index === 0) {
        const phase1_5Duration = isMobileAbout ? 2.0 : 2.5; // 前半画像のキープ時間（モバイルは短く）
        tl.to(card, {
          y: 0,
          duration: phase1_5Duration, // 鮮明な状態でキープする時間
          ease: 'none'
        });
      }

      // Phase 2: 画像切り替え（1枚目のみ）
      if (index === 0 && singleImage && gridImages) {
        const gridImageElements = gridImages.querySelectorAll('img');
        // console.log('gridImageElements found:', gridImageElements.length);

        // CSSで設定されている親要素のスタイルをリセット
        gsap.set(gridImages, {
          opacity: 1,
          filter: 'none',
        });

        // グリッドコンテナをrelativeに設定（子要素がabsoluteで配置できるように）
        gridImages.style.position = 'relative';
        gridImages.style.width = '100%';
        gridImages.style.height = '100%';

        // 右側のテキストエリアを右にずらす
        const textContent = card.querySelector('.about-content, .about-text, [class*="text"]');
        if (textContent) {
          textContent.style.paddingLeft = '50%'; // 左にパディングを追加して右に寄せる
        }

        // 各画像の初期状態を設定
        // wrapperにブラーをかけることでエッジが見えなくなる
        gridImageElements.forEach((img) => {
          const imgWrapper = img.parentElement;
          gsap.set(img, {
            opacity: 1, // 画像自体は見える状態
          });
          if (imgWrapper) {
            gsap.set(imgWrapper, {
              opacity: 0,
              filter: 'blur(30px)',
            });
          }
        });

        // Phase 2-1: 最初の画像を優雅にフェードアウト
        // ゆったりトランジション（長めの時間と滑らかなイージング）
        const phase2TransitionDuration = isMobileAbout ? 2.5 : 2.0;
        // ブラーと縮小（ゆっくり優雅に）
        tl.to(singleImage, {
          scale: 0.85,
          filter: 'blur(40px)',
          duration: phase2TransitionDuration,
          ease: 'power1.inOut'
        });
        // opacityは別途、より早く0にする（ブラーのエッジが見える前に消す）
        tl.to(singleImage, {
          opacity: 0,
          duration: phase2TransitionDuration * 0.7,
          ease: 'power2.inOut'
        }, '<'); // 同時開始だが短い時間で完了

        // Phase 2-1b: テキストも同時に切り替え（single → grid）
        // モバイル/デスクトップで適切なテキスト要素を選択
        const textGroupSuffix = isMobileAbout ? '--mobile' : '--desktop';
        const singleText = card.querySelector(`.about-content-card__text-group${textGroupSuffix}[data-text-type="single"]`);
        const gridText = card.querySelector(`.about-content-card__text-group${textGroupSuffix}[data-text-type="grid"]`);

        if (singleText && gridText) {
          // 単一画像用のテキストをフェードアウト
          tl.to(singleText, {
            opacity: 0,
            filter: 'blur(10px)',
            duration: phase2TransitionDuration,
            ease: 'none'
          }, '<'); // 画像と同時に開始

          // gridText親要素の初期状態を設定（非表示、ただしblurなし）
          gsap.set(gridText, {
            opacity: 0
          });

          // pタグの中身を<br>で分割して各行をspanで囲む
          const pElements = gridText.querySelectorAll('.about-content-card__body p');
          pElements.forEach(p => {
            const html = p.innerHTML;
            const lines = html.split('<br>');
            const wrappedLines = lines.map(line => `<span class="text-line">${line}</span>`).join('<br>');
            p.innerHTML = wrappedLines;
          });

          // heading と 各行のspanを取得
          const heading = gridText.querySelector('.about-content-card__heading');
          const textLines = gridText.querySelectorAll('.text-line');
          const allElements = [heading, ...textLines].filter(el => el);

          // 子要素の初期状態を設定（全て非表示）
          gsap.set(allElements, {
            opacity: 0,
            x: -50
          });

        }

        // Phase 2-2: グリッド画像をランダムっぽく配置
        // ランダムっぽい位置とサイズを設定
        // 右の2つは中央を基準に配置（top: 50% + translateY）で画面高さに対応
        const isMobileGrid = window.innerWidth <= 749;
        const randomLayouts = isMobileGrid ? [
          { left: '0', top: '50%', width: '52%', zIndex: 2, translateY: '-45%' },    // imgIndex 0: 左上、大きめ（2番目に表示）
          { right: '0', top: '50%', width: '40%', zIndex: 3, translateY: '-90%' },   // imgIndex 1: 中央より上（最初に表示）
          { right: '5%', top: '50%', width: '30%', zIndex: 1, translateY: '50%' }    // imgIndex 2: 中央より下、小さめ（最後に表示）
        ] : [
          { left: '0', top: '50%', width: '50%', zIndex: 2, translateY: '-45%' },    // imgIndex 0: 左上、大きめ（2番目に表示）
          { right: '0', top: '50%', width: '35%', zIndex: 3, translateY: '-90%' },   // imgIndex 1: 中央より上（最初に表示）
          { right: '5%', top: '50%', width: '25%', zIndex: 1, translateY: '50%' }    // imgIndex 2: 中央より下、小さめ（最後に表示）
        ];

        // まず全ての画像の位置とサイズを設定
        gridImageElements.forEach((img, imgIndex) => {
          const layout = randomLayouts[imgIndex];

          // 親要素に position: absolute を設定
          const imgWrapper = img.parentElement;
          if (imgWrapper) {
            imgWrapper.style.position = 'absolute';
            imgWrapper.style.opacity = '0'; // 初期非表示（画像と一緒にアニメーション）
            imgWrapper.style.background = 'transparent'; // 背景を透明に

            // leftとrightを分岐して設定
            if (layout.left !== undefined) {
              imgWrapper.style.left = layout.left;
              imgWrapper.style.right = 'auto'; // rightをリセット
            } else if (layout.right !== undefined) {
              imgWrapper.style.right = layout.right;
              imgWrapper.style.left = 'auto'; // leftをリセット
            }

            // topを設定（中央基準の場合はtransformで調整）
            imgWrapper.style.top = layout.top;
            imgWrapper.style.bottom = 'auto';

            // translateYで中央からの位置を調整
            if (layout.translateY) {
              imgWrapper.style.transform = `translateY(${layout.translateY})`;
            } else {
              imgWrapper.style.transform = 'none';
            }

            imgWrapper.style.width = layout.width;
            imgWrapper.style.height = 'auto'; // 縦長にならないようにauto
            imgWrapper.style.zIndex = layout.zIndex;
          }

          // img要素自体にもheight: autoを設定
          img.style.height = 'auto';
          img.style.width = '100%';
        });

        // grid画像とテキストを同時にアニメーション（上スクロールでも同時に消える）
        const gridImageWrappers = gridImages.querySelectorAll('.about-image--grid');
        // 表示順序: imgIndex 1 → 0 → 2
        const imageOrder = [1, 0, 2];
        const sortedWrappers = imageOrder.map(idx => gridImageWrappers[idx]).filter(w => w);

        // gridテキストの初期設定
        let gridAllElements = [];
        if (gridText) {
          const gridHeading = gridText.querySelector('.about-content-card__heading');
          const gridTextLines = gridText.querySelectorAll('.text-line');
          gridAllElements = [gridHeading, ...gridTextLines].filter(el => el);

          // 初期状態：非表示（CSSのblur(10px)を上書き）
          gsap.set(gridText, { opacity: 0, filter: 'blur(10px)' });
          gsap.set(gridAllElements, { opacity: 0, x: -50 });
        }

        // ラベルを追加して画像とテキストを同時にアニメーション
        const gridAnimLabel = 'gridAnim';
        tl.addLabel(gridAnimLabel);

        // アニメーション時間の計算（テキストが少し先に完了するように）
        const imageInterval = 0.25;
        const imageFadeInDuration = 0.4;
        const imageBlurDuration = 0.6;
        const lastImageStart = (sortedWrappers.length - 1) * imageInterval;
        const totalImageTime = lastImageStart + imageFadeInDuration + imageBlurDuration;

        // テキストのstaggerとdurationを計算（画像より少し早く完了）
        const textElementCount = gridAllElements.length;
        const textStagger = 0.1;
        const textTotalTime = totalImageTime * 0.85; // 画像より15%早く完了
        const textDuration = Math.max(textTotalTime - (textElementCount - 1) * textStagger, 0.6);

        // 画像をフェードイン（ブラー状態で）- ゆったり順次登場
        sortedWrappers.forEach((wrapper, i) => {
          tl.to(wrapper, {
            opacity: 1,
            filter: 'blur(20px)',
            duration: imageFadeInDuration,
            ease: 'power2.out'
          }, `${gridAnimLabel}+=${i * imageInterval}`);
        });

        // gridText親要素のopacity・filterをscrubで管理（上スクロールで塊としてブラー＆フェードアウト）
        if (gridText) {
          gsap.set(gridText, { opacity: 0, filter: 'blur(10px)' });
          tl.to(gridText, {
            opacity: 1,
            filter: 'blur(0px)',
            duration: totalImageTime,
            ease: 'power2.out'
          }, gridAnimLabel);
        }

        // ブラー解除（画像）- フェードイン完了後に開始
        sortedWrappers.forEach((wrapper, i) => {
          tl.to(wrapper, {
            filter: 'blur(0px)',
            duration: imageBlurDuration,
            ease: 'power1.out'
          }, `${gridAnimLabel}+=${i * imageInterval + imageFadeInDuration}`);
        });

        // 子要素のアニメーションはtl.call()で一度だけ発火（1行ずつ左からスライドイン）
        // 上スクロール時は親要素のopacity/blurで塊として消える
        if (gridText && gridAllElements.length > 0) {
          let gridTextAnimated = false;

          // gridAnimラベルの位置を記録
          const gridAnimLabelTime = tl.labels[gridAnimLabel];

          tl.call(() => {
            if (!gridTextAnimated) {
              gridTextAnimated = true;
              // 子要素を1行ずつ左からスライドイン
              gsap.to(gridAllElements, {
                opacity: 1,
                x: 0,
                duration: textDuration,
                stagger: textStagger,
                ease: 'power2.out'
              });
            }
          }, null, gridAnimLabel);

          // タイムラインの進行を監視して、gridAnimより前に戻ったらリセット
          tl.eventCallback('onUpdate', function() {
            const currentTime = tl.time();
            // gridAnimの開始位置より前に戻ったらリセット
            if (gridTextAnimated && currentTime < gridAnimLabelTime) {
              gridTextAnimated = false;
              gsap.set(gridAllElements, { opacity: 0, x: -50 });
            }
          });

          // リセット関数を保存（既存のresetSingleTextに追加）
          const existingReset = card._resetSingleText;
          card._resetSingleText = () => {
            if (existingReset) existingReset();
            gridTextAnimated = false;
            gsap.set(gridText, { opacity: 0, filter: 'blur(10px)' });
            gsap.set(gridAllElements, { opacity: 0, x: -50 });
          };
        }

        // 画像リセット関数を追加（既存のresetSingleTextに追加）
        const existingResetForImages = card._resetSingleText;
        card._resetSingleText = () => {
          if (existingResetForImages) existingResetForImages();
          // single画像を初期状態に戻す
          gsap.set(singleImage, {
            opacity: 1,
            scale: 1,
            filter: 'blur(0px)'
          });
          // grid画像を初期状態に戻す
          gridImageElements.forEach((img) => {
            const imgWrapper = img.parentElement;
            if (imgWrapper) {
              gsap.set(imgWrapper, {
                opacity: 0,
                filter: 'blur(30px)'
              });
            }
          });
          // singleTextを表示状態に戻す
          if (singleText) {
            gsap.set(singleText, {
              opacity: 1,
              filter: 'blur(0px)'
            });
          }
          // gridTextを非表示に戻す
          if (gridText) {
            gsap.set(gridText, {
              opacity: 0
            });
          }
        };

        // Phase 2.5: グリッド画像が鮮明になった後、キープする時間
        // 後半のテキストを読む時間を確保（長めに）
        const phase2_5Duration = isMobileAbout ? 3.5 : 1.5; // 後半キープ（モバイルは長く、2枚目登場まで間を取る）
        tl.to(card, {
          y: 0,
          duration: phase2_5Duration, // 鮮明な状態でキープする時間（長めに）
          ease: 'none'
        });

        // Phase 2.6は削除 - onLeaveBackでテキストリセットを処理

        // デバッグ：アニメーション完了時の状態を確認
        // tl.eventCallback('onComplete', () => {
        //   console.log('Timeline complete');
        //   console.log('gridImages opacity:', window.getComputedStyle(gridImages).opacity);

        //   gridImageElements.forEach((img, i) => {
        //     console.log(`Image ${i}:`, {
        //       opacity: window.getComputedStyle(img).opacity,
        //       filter: window.getComputedStyle(img).filter
        //     });
        //   });
        // });
      }

      // Phase 3: 固定を維持（後続のカードが表示されている間）
      if (remainingCards > 1) {
        // 残りの期間は何もせずpinだけ維持
        const holdDuration = (remainingCards - 1) * 2;
        tl.to(card, {
          y: 0,
          duration: holdDuration,
          ease: 'none'
        });
      }

      // Phase 3b: 2枚目カードの場合、入場完了後にキープ時間を追加
      // テキストを読む時間を確保し、フッターが早く出ないようにする
      if (index === 1) {
        const phase3bKeepDuration = isMobileAbout ? 2.5 : 2.5; // 2枚目が画面トップに固定される時間
        tl.to(card, {
          y: 0,
          duration: phase3bKeepDuration,
          ease: 'none'
        });
      }

      // Phase 4: 2枚目カードの場合、タイムラインの最後でフッターモードを開始
      if (index === 1) {
        secondCardScrollTrigger = tl.scrollTrigger;
        // タイムラインへの参照を保存（リバースモードで使用）
        card._timeline = tl;

        if (footer) {
          // フッター用スクロール監視（通常スクロールのように振る舞う）
          // 2枚目カードが上に移動すると、その後ろにあるフッターが見えてくる
          // フッター高さを動的に取得（リサイズ対応）
          const getFooterHeight = () => {
            const height = footer.offsetHeight;
            // モバイルはフッターが縦積みで高くなる、タブレットも2段構成で高くなる
            // 最低限の高さを確保
            if (isMobileAbout) {
              return Math.max(height, 500); // モバイル最低500px
            } else if (window.innerWidth <= 1199) {
              return Math.max(height, 400); // タブレット最低400px
            }
            return height || 324;
          };
          let footerH = getFooterHeight();

          // 状態管理をシンプルに
          // footerMode: フッターが見えている状態（カードとフッターが一緒に動く）
          // reverseMode: フッターが戻った後、カードがGSAPタイムラインで逆再生

          // 現在のフッター位置を追跡
          let currentFooterY = 0;

          function applyFooterTransform(y) {
            card.style.transform = `translate3d(0, ${y}px, 0)`;
            footer.style.transform = `translate3d(0, ${y}px, 0)`;
          }

          const updateFooterPosition = () => {
            if (!secondCardScrollTrigger) {
              return;
            }

            // フッター高さを再取得（リサイズ対応）
            footerH = getFooterHeight();

            const scrollY = window.scrollY;
            const triggerEnd = secondCardScrollTrigger.end;
            const triggerStart = secondCardScrollTrigger.start;

            // 2枚目のScrollTriggerが終了した後のスクロール量
            const scrollBeyondEnd = scrollY - triggerEnd;

            // about-heroを取得（隙間対策用）
            const aboutHero = document.querySelector('.about-hero');

            // GSAPが無効化された後は2枚目カードを常に表示状態に維持
            // ただしリバースモード中はタイムラインがopacityを制御するので除外
            if (card._gsapDisabled && !card._reverseMode) {
              card.style.opacity = '1';
              card.style.visibility = 'visible';
            }

            // ===== モバイル: カード→フッターが連続するネイティブスクロール方式 =====
            // フッターモード: カードをbodyに移動、position: absoluteでネイティブスクロール
            // リバースモード: bodyに残したままposition: fixedに切り替え（DOM移動なし→ガクつかない）
            // リバース完了後（カード非表示時）にpin-spacerに戻す（見えないので影響なし）
            if (isMobileAbout) {
              const mobileFooterGap = 0;

              if (scrollBeyondEnd >= 0 && card._gsapDisabled) {
                // === フッターモード: triggerEnd以降（下スクロール） ===
                if (!card._footerMode) {
                  card._footerMode = true;
                  card._reverseMode = false;
                  if (card._lerpRAF) {
                    cancelAnimationFrame(card._lerpRAF);
                    card._lerpRAF = null;
                  }
                  // pin-spacerを記憶（リバース完了後の復帰用）
                  if (!card._pinSpacer) {
                    card._pinSpacer = card.parentElement;
                  }
                  // カードをbodyに移動（まだbodyにいなければ）
                  if (card.parentElement !== document.body) {
                    document.body.appendChild(card);
                  }
                  card.style.position = 'absolute';
                  card.style.top = triggerEnd + 'px';
                  card.style.left = '0';
                  card.style.width = '100%';
                  card.style.minHeight = '100vh';
                  card.style.zIndex = '11';
                  card.style.opacity = '1';
                  card.style.pointerEvents = 'auto';
                  card.style.transform = 'none';
                  card._timeline.progress(1);
                  card._lerpCurrent = 1.0;
                  // DOM移動で失われるCSSを補完
                  card.querySelectorAll('p, .text-line').forEach(el => {
                    el.style.color = '#ffffff';
                  });
                  card.querySelectorAll('.about-content-card__text-group').forEach(el => {
                    el.style.top = '15%';
                  });
                  // フッター: カードの直後に配置
                  // card.offsetHeight（CSS 100vh = large viewport）を使用
                  // window.innerHeightはiOSアドレスバーで変動するため不安定
                  const stableCardHeight = card.offsetHeight;
                  footer.style.cssText = `
                    position: absolute !important;
                    top: ${triggerEnd + stableCardHeight + mobileFooterGap}px !important;
                    left: 0 !important;
                    width: 100% !important;
                    z-index: 11 !important;
                    pointer-events: auto !important;
                  `;
                  if (aboutHero) aboutHero.style.visibility = 'hidden';
                }
                // カードは自然にスクロールアウト、opacity管理不要
              } else if (scrollBeyondEnd < 0 && card._gsapDisabled) {
                // === triggerEnd未満に戻った（上スクロール） ===
                if (card._footerMode) {
                  // フッターモード終了 → リバースモード開始
                  // fixed; top: 0 で完全固定（onUpdateガードでテキスト消失を防止済み）
                  card._footerMode = false;
                  card._reverseMode = true;
                  card._lerpCurrent = 1.0;
                  card.style.position = 'fixed';
                  card.style.top = '0px';
                  card.style.left = '0';
                  card.style.width = '100%';
                  card.style.minHeight = '';
                  card.style.zIndex = '11';
                  card.style.opacity = '1';
                  // フッターを非表示
                  footer.style.cssText = `
                    position: fixed !important;
                    top: 100vh !important;
                    top: 100lvh !important;
                    left: 0 !important;
                    width: 100% !important;
                    z-index: 11 !important;
                    pointer-events: none !important;
                  `;
                  footer.style.transform = '';
                  if (aboutHero) aboutHero.style.visibility = 'visible';
                }

                if (card._reverseMode) {
                  const scrollProgress = (scrollY - triggerStart) / (triggerEnd - triggerStart);
                  card._lerpTarget = Math.max(0, Math.min(1, scrollProgress));

                  if (!card._lerpRAF) {
                    const lerpFactor = 0.05;
                    const lerpLoop = () => {
                      const diff = card._lerpTarget - card._lerpCurrent;
                      if (Math.abs(diff) < 0.0005) {
                        card._lerpCurrent = card._lerpTarget;
                      } else {
                        card._lerpCurrent += diff * lerpFactor;
                      }

                      card._timeline.progress(card._lerpCurrent);

                      // リバース完了（カードが非表示になった時点で安全にpin-spacerに戻す）
                      if (card._lerpCurrent <= 0.005 && card._lerpTarget <= 0.005) {
                        card._reverseMode = false;
                        card._lerpRAF = null;

                        // インラインスタイルをクリア
                        card.querySelectorAll('p, .text-line').forEach(el => {
                          el.style.color = '';
                        });
                        card.querySelectorAll('.about-content-card__text-group').forEach(el => {
                          el.style.top = '';
                        });
                        // カードは今opacity: 0なので、pin-spacerに戻しても見えない
                        if (card._pinSpacer) {
                          card._pinSpacer.appendChild(card);
                        }
                        card.style.transform = '';
                        card.style.position = '';
                        card.style.top = '';
                        card.style.left = '';
                        card.style.right = '';
                        card.style.width = '';
                        footer.style.transform = '';

                        const extraOffset = window.innerHeight * 3.0;
                        const initialY2 = window.innerHeight * 1.2 + window.innerHeight * 1.1 + extraOffset;
                        gsap.set(card, {
                          y: initialY2,
                          rotation: -15,
                          opacity: 0
                        });

                        secondCardScrollTrigger.enable();
                        if (firstCardScrollTrigger) firstCardScrollTrigger.enable();
                        ScrollTrigger.refresh();
                        card._gsapDisabled = false;

                        if (aboutHero) aboutHero.style.visibility = 'visible';
                        return;
                      }

                      card._lerpRAF = requestAnimationFrame(lerpLoop);
                    };
                    card._lerpRAF = requestAnimationFrame(lerpLoop);
                  }
                }
              }
              return; // モバイル処理完了
            }

            // ===== デスクトップ/タブレット: 既存のtransform方式 =====
            if (scrollBeyondEnd >= 0 && card._gsapDisabled) {
              // フッターモードON - triggerEnd以降（下スクロール）
              card._footerMode = true;
              card._reverseMode = false;

              // スクロール可能量が足りないので、移動速度を上げる
              const isTablet = window.innerWidth >= 750 && window.innerWidth <= 1199;
              const footerSpeed = isTablet ? 1.3 : 1.0;

              // スクロール量に速度を掛けて移動、フッターの高さを上限に
              const moveY = Math.max(-scrollBeyondEnd * footerSpeed, -footerH);
              currentFooterY = moveY;

              // カードとフッターを一緒に動かす
              applyFooterTransform(moveY);
              footer.style.pointerEvents = 'auto';

              // フッターが見えている間はabout-heroを非表示
              if (aboutHero) {
                aboutHero.style.visibility = 'hidden';
              }
            } else if (scrollBeyondEnd < 0 && card._gsapDisabled) {
              // triggerEnd未満に戻った（上スクロール）

              if (currentFooterY < 0) {
                // フッターがまだ見えている状態 - フッターを戻す
                // スクロール量に応じてフッターを戻す（triggerEndからどれだけ戻ったか）
                const returnAmount = -scrollBeyondEnd; // 正の値
                const moveY = Math.min(currentFooterY + returnAmount, 0);

                applyFooterTransform(moveY);

                if (moveY >= 0) {
                  // フッターが完全に戻った
                  currentFooterY = 0;
                  card._footerMode = false;
                  card._reverseMode = true;
                  footer.style.pointerEvents = 'none';
                  // about-heroを再表示
                  if (aboutHero) {
                    aboutHero.style.visibility = 'visible';
                  }
                } else {
                  currentFooterY = moveY;
                }
              } else if (card._reverseMode) {
                // リバースモード: GSAPのタイムラインを使って逆再生
                const scrollProgress = (scrollY - triggerStart) / (triggerEnd - triggerStart);
                const clampedProgress = Math.max(0, Math.min(1, scrollProgress));

                // GSAPタイムラインのprogressを直接設定
                if (card._timeline) {
                  card._timeline.progress(clampedProgress);
                }

                // リバースモード終了判定（タイムラインの最初に戻った）
                if (clampedProgress <= 0.01) {
                  card._reverseMode = false;
                  card._footerMode = false;
                  // 状態を完全にリセット（次の下スクロールに備える）
                  currentFooterY = 0;

                  // GSAPを再有効化 - enable()だけでは内部状態がリセットされないため
                  // ScrollTrigger.refresh()を呼んで完全にリセットする
                  if (card._gsapDisabled && secondCardScrollTrigger) {
                    // カードのtransformをリセット
                    card.style.transform = '';
                    footer.style.transform = '';

                    // 2枚目カードの位置を初期状態に戻す
                    const initialY2 = window.innerHeight * 1.2 + window.innerHeight * 1.1 + window.innerHeight * (isMobileAbout ? 4.0 : 3.0);
                    gsap.set(card, {
                      y: initialY2,
                      rotation: -15,
                      opacity: 0
                    });

                    // ScrollTriggerを有効化してリフレッシュ
                    secondCardScrollTrigger.enable();

                    // 1枚目のScrollTriggerも有効な状態か確認
                    if (firstCardScrollTrigger) {
                      firstCardScrollTrigger.enable();
                    }

                    // 全ScrollTriggerをリフレッシュして内部状態をリセット
                    ScrollTrigger.refresh();

                    card._gsapDisabled = false;
                  }
                  // about-heroを再表示
                  if (aboutHero) {
                    aboutHero.style.visibility = 'visible';
                  }
                }
              } else if (card._footerMode) {
                // フッターモードだがフッターは完全に戻っている -> リバースモードに移行
                card._footerMode = false;
                card._reverseMode = true;
                footer.style.pointerEvents = 'none';
              }
            }
          };

          // スクロールイベントを即座に登録
          window.addEventListener('scroll', updateFooterPosition, { passive: true });

          // 初期状態でも一度実行
          updateFooterPosition();
        }
      }
    });

    // ヘッダーのスタイルを制御するScrollTrigger
    // console.log('🔍 Checking header style control prerequisites:', {
    //   header: !!header,
    //   firstCardScrollTrigger: !!firstCardScrollTrigger,
    //   secondCardScrollTrigger: !!secondCardScrollTrigger
    // });

    // ヘッダーの色制御：1枚目カードが画面トップに到達した時のみScrollTriggerで制御
    // 2枚目カードのテキストアニメーション開始時の色変更は、2枚目のtl.call()内で行う
    if (header && firstCardScrollTrigger) {
      ScrollTrigger.create({
        trigger: firstCardScrollTrigger.trigger,
        // start: 1枚目のカードが画面トップに到達した瞬間
        start: () => firstCardScrollTrigger.start + window.innerHeight * (isMobileAbout ? 0.8 : 1.0),
        // end: 1枚目カードのpin終了位置（ここまで背景付きヘッダー）
        end: () => firstCardScrollTrigger.end,
        markers: true, // 必須: レイアウト計算に必要（CSSで非表示）
        id: 'header-style-control',
        onEnter: () => {
          // 1枚目のカードが画面トップに到達したら、背景付きヘッダーに
          header.classList.remove('hdr-trans-hp');
        },
        onLeaveBack: () => {
          // 1枚目のカードが画面トップより上に戻ったら、透明ヘッダーに
          header.classList.add('hdr-trans-hp');
        }
        // onLeave, onEnterBackは削除（2枚目のtl.call()で制御するため）
      });
    }

    // デバッグ：ScrollTrigger一覧を表示
    // setTimeout(() => {
    //   console.log('=== All ScrollTriggers ===');
    //   ScrollTrigger.getAll().forEach((st, i) => {
    //     console.log(`ScrollTrigger ${i}:`, {
    //       id: st.vars.id || 'no-id',
    //       trigger: st.trigger.className || st.trigger.tagName,
    //       start: st.start,
    //       end: st.end,
    //       pin: st.pin ? 'yes' : 'no',
    //       scrub: st.vars.scrub ? 'yes' : 'no'
    //     });
    //   });

    //   console.log('=== Footer element check ===');
    //   if (footer) {
    //     const computedStyle = window.getComputedStyle(footer);
    //     console.log('Footer computed styles:', {
    //       position: computedStyle.position,
    //       bottom: computedStyle.bottom,
    //       transform: computedStyle.transform,
    //       zIndex: computedStyle.zIndex
    //     });
    //   }
    // }, 500);
  }
}

// 初期化
function initAboutAnimations() {
  if (typeof gsap === 'undefined') {
    console.warn('GSAP not loaded yet, retrying...');
    setTimeout(initAboutAnimations, 100);
    return;
  }

  new AboutPageAnimation();
  // console.log('About animations initialized with ScrollTrigger');

  // ページ完全読み込み後にScrollTriggerをリフレッシュ（1回だけ）
  // 初回読み込み時のタイミングずれを修正
  if (document.readyState === 'complete') {
    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 100);
  } else {
    window.addEventListener('load', () => {
      setTimeout(() => {
        ScrollTrigger.refresh();
      }, 100);
    }, { once: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAboutAnimations);
} else {
  initAboutAnimations();
}